import { Component, Prop } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import VueBase from '@/VueBase';
import { locales } from '@/i18n-setup';
import helper, { _loadComponent } from '@/services/helper';
import Q from 'q';
import _ from 'lodash';
import api from '@/services/api';
import { Route, RawLocation } from 'vue-router';

@Component<SubjectConfirmMixins>({
  computed: {
    ...mapState({
      CandidatesPerRow: 'CandidatesPerRow',
      ShowCandidateName: 'ShowCandidateName',
      ShowCandidatePicture: 'ShowCandidatePicture',
    }),
    ...mapGetters({
      PrevSubject: 'PrevSubject',
      NextSubject: 'NextSubject',
      subject: 'SubjectConfirmData',
    }),
  },
  watch: {
    subjectIndex(val, old) {
      if (_.isNumber(Number(val)) && val != old) this.loadSubject();
    },
  },
})
export default class SubjectConfirmMixins extends VueBase {
  @Prop() public readonly subjectIndex!: number;

  public readonly CandidatesPerRow!: number;
  public readonly ShowCandidateName!: boolean;
  public readonly ShowCandidatePicture!: boolean;
  public readonly PrevSubject!: string;
  public readonly NextSubject!: string;

  public readonly subject!: SubjectSimpleModel | null;

  public loading: boolean = true;

  get IsFirst() {
    return this.PrevSubject === null;
  }

  get IsLast() {
    return this.NextSubject === null;
  }

  get NextText() {
    return this.IsLast ? this.$t('vs.confirm.navigation.next.finallabel') : this.NextSubject;
  }

  get candidateWidth() {
    return 100.0 / this.CandidatesPerRow;
  }

  mounted() {
    this.loadSubject();
  }

  public async loadSubject() {
    this.loading = true;
    helper.swalShowLoading();

    await Q.delay(100);
    this.$store.commit('SelectSubject', this.subjectIndex);
    await Q.delay(100);
    await this.$nextTick();
    this.loading = false;
    if (!this.subject) {
      this.$router.push({ name: 'Start' });
      return;
    }

    helper.close();
    this.onLoaded();
    return true;
  }

  // ToOverride if needed
  onLoaded() {}

  public async onGoNext() {
    if (!this.subject) return;

    if (this.IsLast) {
      helper.swalShowLoading();
      await Q.delay(500);
      this.$router.push({ name: 'FinalConfirm' });
    } else {
      this.$router.push({ name: 'Vote', params: { subjectIndex: String(Number(this.subjectIndex) + 1) } });
    }
  }

  public onGoPrev() {
    this.$router.push({
      name: 'Vote',
      params: { subjectIndex: String(this.subjectIndex) },
    });
  }
}
